var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _path10, _path11, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 50,
    viewBox: "0 0 82 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1526 39.89L11.5226 41.08C9.46456 40.66 7.68656 39.344 6.86056 37.608C6.03456 39.344 4.25656 40.66 2.19856 41.08L1.58256 39.89C4.07456 39.428 6.10456 37.482 6.10456 35.48V34.528H7.63056V35.48C7.63056 37.496 9.66056 39.442 12.1526 39.89ZM1.19056 43.544H12.6426V44.734H1.19056V43.544ZM24.4575 33.73V41.892H23.0015V33.73H24.4575ZM18.1855 35.102C17.1355 35.102 16.4075 35.564 16.4075 36.32C16.4075 37.076 17.1355 37.538 18.1855 37.538C19.2355 37.538 19.9495 37.076 19.9495 36.32C19.9495 35.564 19.2355 35.102 18.1855 35.102ZM18.1855 38.616C16.3095 38.616 15.0075 37.692 15.0075 36.32C15.0075 34.934 16.3095 34.024 18.1855 34.024C20.0475 34.024 21.3495 34.934 21.3495 36.32C21.3495 37.692 20.0475 38.616 18.1855 38.616ZM20.2575 45.266C22.0635 45.266 23.0855 44.888 23.0855 44.16C23.0855 43.446 22.0635 43.068 20.2575 43.068C18.4515 43.068 17.4295 43.446 17.4295 44.16C17.4295 44.888 18.4515 45.266 20.2575 45.266ZM18.8995 40.478V42.046C19.3055 41.99 19.7675 41.962 20.2575 41.962C22.9175 41.962 24.5415 42.774 24.5415 44.16C24.5415 45.56 22.9175 46.372 20.2575 46.372C17.5975 46.372 15.9735 45.56 15.9735 44.16C15.9735 43.376 16.5055 42.774 17.4435 42.396V40.562C16.3095 40.618 15.2315 40.632 14.2935 40.632L14.1115 39.484C16.4355 39.484 19.5715 39.456 22.2455 39.064L22.3435 40.072C21.2095 40.282 20.0475 40.394 18.8995 40.478ZM33.3744 43.656H38.4004V44.846H26.9484V43.656H31.9324V40.674H28.3484V34.668H37.0004V35.83H29.7904V39.512H37.1124V40.674H33.3744V43.656ZM43.2293 42.27C44.3213 42.27 45.0633 41.094 45.0633 39.092C45.0633 37.132 44.3213 35.942 43.2293 35.942C42.1513 35.942 41.4093 37.132 41.4093 39.092C41.4093 41.094 42.1513 42.27 43.2293 42.27ZM48.8713 33.702H50.3273V46.386H48.8713V39.596H46.4213C46.2533 42.046 44.9653 43.558 43.2293 43.558C41.3673 43.558 40.0373 41.836 40.0373 39.092C40.0373 36.376 41.3673 34.64 43.2293 34.64C44.9233 34.64 46.2113 36.096 46.4073 38.42H48.8713V33.702ZM63.0887 38.602L63.2287 39.75C61.5907 40.1 60.1067 40.184 57.3907 40.184H56.3687V34.5H61.9687V35.676H57.8107V39.008C60.2047 38.994 61.5627 38.91 63.0887 38.602ZM59.1267 42.634V45.042H66.0427V46.204H57.6847V41.486H65.8187V42.634H59.1267ZM65.7207 36.6H67.5127V37.79H65.7207V40.814H64.2787V33.702H65.7207V36.6ZM69.4436 35.046H75.4356C75.4356 38.812 73.9236 42.004 69.5836 44.104L68.8136 42.956C72.1316 41.36 73.6996 39.134 73.9516 36.222H69.4436V35.046ZM77.7176 33.716H79.1596V46.358H77.7176V33.716Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 25,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 0H28V4.10821H53V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3103_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 1.35257C53 0.605867 52.3924 0 51.6421 0H29.3597C28.6094 0 28.0009 0.605867 28.0009 1.35257V2.70426C28.0009 3.45096 28.6094 4.05594 29.3597 4.05594H51.6421C52.3924 4.05594 53 3.45096 53 2.70426V1.35257Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 22,
    width: 25,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 22.9297H28V27.0414H53V22.9297Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3103_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 24.337C53 23.5912 52.3924 22.9854 51.6421 22.9854H29.3597C28.6094 22.9854 28.0009 23.5912 28.0009 24.337V25.6896C28.0009 26.4363 28.6094 27.0413 29.3597 27.0413H51.6421C52.3924 27.0413 53 26.4363 53 25.6896V24.337Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9473 21.2465V21.917H29.3604V5.15112H42.9473V6.33274C39.7921 7.35669 37.5122 10.3081 37.5122 13.79C37.5122 17.2711 39.7921 20.2225 42.9473 21.2465ZM31.5341 11.6261C31.8344 11.6261 32.0771 11.8688 32.0771 12.1673V15.1417C32.0771 15.4402 31.8344 15.6829 31.5341 15.6829C31.2338 15.6829 30.9902 15.4402 30.9902 15.1417V12.1673C30.9902 11.8688 31.2338 11.6261 31.5341 11.6261Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3926 20.5512C49.1438 20.5512 52.1855 17.5245 52.1855 13.791C52.1855 10.0574 49.1438 7.03076 45.3926 7.03076C41.6404 7.03076 38.5987 10.0574 38.5987 13.791C38.5987 17.5245 41.6404 20.5512 45.3926 20.5512ZM42.2224 13.791C42.2224 13.4916 42.4651 13.2498 42.7654 13.2498H46.5255L45.2801 12.0097C45.0675 11.7989 45.0675 11.4561 45.2801 11.2453C45.4918 11.0336 45.8363 11.0336 46.048 11.2453L48.0304 13.217C48.3484 13.5341 48.3484 14.047 48.0304 14.3641L46.048 16.3367C45.8363 16.5475 45.4918 16.5475 45.2801 16.3367C45.0675 16.125 45.0675 15.7822 45.2801 15.5714L46.5255 14.3313H42.7654C42.4651 14.3313 42.2224 14.0895 42.2224 13.791Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 9,
    width: 4,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9023 9.91162H30.6259V15.841H33.9023V9.91162Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3103_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9023 9.91162H30.5807V15.8906H33.9023V9.91162Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 16,
    width: 12,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9102 16.9834H30.6245V22.1102H41.9102V16.9834Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3103_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9102 16.9834H30.6166V22.1652H41.9102V16.9834Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 7,
    width: 15,
    height: 14
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2461 7.04443H38.6407V20.6499H52.2461V7.04443Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3103_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2461 13.8472C52.2461 10.0906 49.1999 7.04443 45.4434 7.04443C41.6868 7.04443 38.6407 10.0906 38.6407 13.8472C38.6407 17.6037 41.6868 20.6499 45.4434 20.6499C49.1999 20.6499 52.2461 17.6037 52.2461 13.8472Z",
    fill: "black"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6166 13.0202C43.4014 13.0202 45.1889 13.0202 46.9746 13.0202C46.6557 12.7013 46.3377 12.3833 46.0197 12.0654C45.2854 11.331 46.429 10.1955 47.1659 10.9333C47.9419 11.7093 48.7178 12.4852 49.4937 13.2611C49.8064 13.5738 49.7984 14.092 49.4884 14.3994C48.7125 15.1753 47.9365 15.9512 47.1606 16.7272C46.4254 17.4615 45.2907 16.3179 46.0286 15.581C46.3439 15.2656 46.6619 14.9476 46.9773 14.6323C45.1951 14.6323 43.412 14.6323 41.6299 14.6323C40.5882 14.6323 40.5802 13.0202 41.6166 13.0202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 18,
    width: 3,
    height: 3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.418 18.8042H35.0485V20.3986H37.418V18.8042Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3103_3973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3103_3973",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 18,
    width: 3,
    height: 3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6729 18.8042H35.8535C35.4434 18.8042 35.1104 19.1372 35.1104 19.5474C35.1104 19.9575 35.4434 20.2905 35.8535 20.2905H36.6729C37.083 20.2905 37.416 19.9575 37.416 19.5474C37.416 19.1372 37.083 18.8042 36.6729 18.8042Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3103_3973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.416 18.8042H35.1573V20.2657H37.416V18.8042Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.cd760a677923c87c2d0f8b0078c51bbd.svg";
export { ForwardRef as ReactComponent };